var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationOffice01 = function SvgLocationOffice01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "location_office-01_svg2__a",
    x1: 49.82,
    x2: 188.74,
    y1: 200.81,
    y2: 33.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#location_office-01_svg2__a",
    id: "location_office-01_svg2__b",
    x1: 81.28,
    x2: 220.19,
    y1: 226.95,
    y2: 59.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#location_office-01_svg2__a",
    id: "location_office-01_svg2__c",
    x1: 14.64,
    x2: 153.56,
    y1: 171.57,
    y2: 4.42
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#location_office-01_svg2__a",
    id: "location_office-01_svg2__d",
    x1: 36.29,
    x2: 175.21,
    y1: 189.56,
    y2: 22.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#location_office-01_svg2__a",
    id: "location_office-01_svg2__e",
    x1: 31.43,
    x2: 170.35,
    y1: 185.52,
    y2: 18.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#location_office-01_svg2__a",
    id: "location_office-01_svg2__f",
    x1: 53.08,
    x2: 192,
    y1: 203.52,
    y2: 36.36
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#location_office-01_svg2__a",
    id: "location_office-01_svg2__g",
    x1: 48.22,
    x2: 187.14,
    y1: 199.48,
    y2: 32.32
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#location_office-01_svg2__a",
    id: "location_office-01_svg2__h",
    x1: 69.87,
    x2: 208.79,
    y1: 217.47,
    y2: 50.32
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#location_office-01_svg2__a",
    id: "location_office-01_svg2__i",
    x1: 5.7,
    x2: 144.62,
    y1: 164.14,
    y2: -3.01
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#location_office-01_svg2__a",
    id: "location_office-01_svg2__j",
    x1: 15.16,
    x2: 154.08,
    y1: 172,
    y2: 4.85
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#location_office-01_svg2__a",
    id: "location_office-01_svg2__k",
    x1: 24.62,
    x2: 163.54,
    y1: 179.87,
    y2: 12.71
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M196.09 187.85h-12.07v-63.03a3.91 3.91 0 1 0-7.82 0v63.03h-28.05v-32.48a3.91 3.91 0 0 0-3.91-3.91h-25.47a3.91 3.91 0 0 0-3.91 3.91v32.48H87.47V27.05h88.73v63.29a3.91 3.91 0 1 0 7.82 0v-67.2a3.91 3.91 0 0 0-3.91-3.91h-9.61V8.24a3.91 3.91 0 0 0-3.91-3.91H98.07a3.91 3.91 0 0 0-3.91 3.91v10.99h-10.6a3.91 3.91 0 0 0-3.91 3.91v61.01H49.03V71.89a3.91 3.91 0 0 0-3.91-3.91H18.2a3.91 3.91 0 0 0-3.91 3.91v115.96H3.91a3.91 3.91 0 1 0 0 7.82h192.18a3.91 3.91 0 1 0 0-7.82m-94.1-175.7h60.71v7.08h-60.71zM22.14 75.79h19.1v8.36h-19.1zm33.27 112.06H45.9V173.9h9.51zm24.27 0H63.23v-17.86a3.91 3.91 0 0 0-3.91-3.91H42a3.91 3.91 0 0 0-3.91 3.91v17.86H22.13V91.96h57.54v95.89Zm60.67 0h-17.66v-28.57h17.66z",
    style: {
      fill: "url(#location_office-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.95 107.25c-.05-.25-.13-.5-.23-.73-.1-.24-.22-.46-.36-.67-.07-.11-.15-.21-.23-.31s-.17-.19-.26-.28-.18-.18-.28-.26-.2-.16-.31-.23c-.21-.14-.44-.26-.68-.36-.23-.1-.48-.17-.73-.23l-.38-.06c-.26-.03-.52-.03-.77 0a2.5 2.5 0 0 0-.38.06c-.25.05-.5.13-.73.23s-.46.22-.67.36c-.11.07-.21.15-.31.23s-.2.17-.29.26-.18.19-.26.28c-.08.1-.16.2-.23.31-.14.21-.26.44-.36.67s-.17.48-.22.73l-.06.38c-.01.13-.02.25-.02.38s0 .25.02.38c.01.13.03.25.06.38.05.25.13.49.22.73.1.23.22.46.36.67.07.11.15.21.23.31s.17.2.26.29a3.5 3.5 0 0 0 .59.49c.21.14.44.26.67.36.24.1.48.17.73.22l.38.06c.13.01.26.02.38.02s.26 0 .39-.02c.13-.01.25-.03.38-.06.25-.05.49-.13.73-.22.24-.1.46-.22.67-.36.11-.07.21-.15.31-.23s.19-.17.28-.26.18-.19.26-.29.16-.2.23-.31c.14-.21.26-.44.36-.67.1-.24.17-.48.23-.73.02-.12.04-.25.06-.38.01-.13.02-.26.02-.38s0-.26-.02-.38a2.5 2.5 0 0 0-.06-.38Z",
    style: {
      fill: "url(#location_office-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.18 44.94a3.91 3.91 0 0 0-3.91-3.91h-16.56a3.91 3.91 0 0 0-3.91 3.91V61.5a3.91 3.91 0 0 0 3.91 3.91h16.56a3.91 3.91 0 0 0 3.91-3.91zm-7.81 12.66h-8.75v-8.75h8.75z",
    style: {
      fill: "url(#location_office-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.79 44.94a3.91 3.91 0 0 0-3.91-3.91h-16.56a3.91 3.91 0 0 0-3.91 3.91V61.5a3.91 3.91 0 0 0 3.91 3.91h16.56a3.91 3.91 0 0 0 3.91-3.91zm-7.82 12.66h-8.75v-8.75h8.75z",
    style: {
      fill: "url(#location_office-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.18 79.1a3.91 3.91 0 0 0-3.91-3.91h-16.56a3.91 3.91 0 0 0-3.91 3.91v16.56a3.91 3.91 0 0 0 3.91 3.91h16.56a3.91 3.91 0 0 0 3.91-3.91zm-7.81 12.65h-8.75V83h8.75z",
    style: {
      fill: "url(#location_office-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.79 79.1a3.91 3.91 0 0 0-3.91-3.91h-16.56a3.91 3.91 0 0 0-3.91 3.91v16.56a3.91 3.91 0 0 0 3.91 3.91h16.56a3.91 3.91 0 0 0 3.91-3.91zm-7.82 12.65h-8.75V83h8.75z",
    style: {
      fill: "url(#location_office-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.27 109.35h-16.56a3.91 3.91 0 0 0-3.91 3.91v16.56a3.91 3.91 0 0 0 3.91 3.91h16.56a3.91 3.91 0 0 0 3.91-3.91v-16.56a3.91 3.91 0 0 0-3.91-3.91m-3.9 16.56h-8.75v-8.75h8.75z",
    style: {
      fill: "url(#location_office-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.88 109.35h-16.56a3.91 3.91 0 0 0-3.91 3.91v16.56a3.91 3.91 0 0 0 3.91 3.91h16.56a3.91 3.91 0 0 0 3.91-3.91v-16.56a3.91 3.91 0 0 0-3.91-3.91m-3.91 16.56h-8.75v-8.75h8.75z",
    style: {
      fill: "url(#location_office-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.62 100.96a3.91 3.91 0 0 0-3.91 3.91v48.94a3.91 3.91 0 1 0 7.82 0v-48.94a3.91 3.91 0 0 0-3.91-3.91",
    style: {
      fill: "url(#location_office-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.62 157.71a3.91 3.91 0 0 0 3.91-3.91v-48.94a3.91 3.91 0 1 0-7.82 0v48.94a3.91 3.91 0 0 0 3.91 3.91",
    style: {
      fill: "url(#location_office-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.62 157.71a3.91 3.91 0 0 0 3.91-3.91v-48.94a3.91 3.91 0 1 0-7.82 0v48.94a3.91 3.91 0 0 0 3.91 3.91",
    style: {
      fill: "url(#location_office-01_svg2__k)"
    }
  }));
};
export default SvgLocationOffice01;